import {AppUrls} from 'shared/config/model/urls';

import React from 'react';

import Pay from 'shared/ui/icons/Tariff/Pay';
import World from 'shared/ui/icons/Tariff/World';
import TPay from 'shared/ui/icons/Tariff/TPay';
import Spb from 'shared/ui/icons/Tariff/Spb';
import MasterCard from 'shared/ui/icons/Tariff/MasterCard';
import Visa from 'shared/ui/icons/Tariff/Visa';
import UnionPay from 'shared/ui/icons/Tariff/UnionPay';
import AmericanExpress from 'shared/ui/icons/Tariff/AmericanExpress';
import Secure from 'shared/ui/icons/Tariff/Secure';
import Dss from 'shared/ui/icons/Tariff/Dss';
import {runtimeEnv} from 'shared/lib/runtimeEnv';

import styles from './IconsBlock.module.scss';

const IconsBlock: React.FC = () => (
    <div className={styles.container}>
        <div className={styles.icons}>
            <World />
            <Pay />
            <TPay />
            <Spb />
            <MasterCard />
            <Visa />
            <UnionPay />
            <AmericanExpress />
            <Secure />
            <Dss />
        </div>
        <div className={styles.link}>
            По вопросам пишите на {' '}
            <a href={AppUrls.INFO_EMAIL} className={styles.email}>
                {runtimeEnv('REACT_APP_INFO_EMAIL')}
            </a>
        </div>
    </div>
);

export default IconsBlock;
